import { Label } from "@tql/ui-components-react/kendo/labels";
import { TextBox } from "@tql/ui-components-react/tql/inputs/beta";
import { useContext } from "react";

import type { SelectedAddressBookItems } from "~/features/quote/context/quote-address-context.tsx";
import { useQuoteAddressContext } from "~/features/quote/context/quote-address-context.tsx";
import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";
import type { SubGroupKey } from "~/shared/types/quote-details-types";

type CityStateZipRowProps = {
	type: SubGroupKey;
};

export function CityStateZipRow({ type }: Readonly<CityStateZipRowProps>) {
	const { selectedAddressBookItems } = useQuoteAddressContext();
	const addressBookItem =
		selectedAddressBookItems[type as keyof SelectedAddressBookItems];
	const { quoteState } = useContext(QuoteDetailsContext);
	const city =
		addressBookItem?.city ||
		(type === "pickup"
			? quoteState.pickupPostalCode.city.name
			: quoteState.deliveryPostalCode.city.name);
	const state =
		addressBookItem?.stateProvince ||
		(type === "pickup"
			? quoteState.pickupPostalCode.city.state.abbreviation
			: quoteState.deliveryPostalCode.city.state.abbreviation);
	const postalCode =
		addressBookItem?.postalCode ||
		(type === "pickup"
			? quoteState.pickupPostalCode.postalCode
			: quoteState.deliveryPostalCode.postalCode);
	const country =
		addressBookItem?.country ||
		(type === "pickup"
			? quoteState.pickupPostalCode.city.state.countryCode
			: quoteState.deliveryPostalCode.city.state.countryCode);

	return (
		<div className={"pickup-delivery-row"}>
			<div className={"pickup-delivery-city"}>
				<Label editorId={`${type}City`}>City</Label>
				<TextBox
					disabled={true}
					id={`${type}City`}
					name={`${type}City`}
					readOnly={true}
					tabIndex={-1}
					value={city}
				/>
			</div>
			<div className={"pickup-delivery-state"}>
				<Label editorId={`${type}State`}>State</Label>
				<TextBox
					disabled={true}
					id={`${type}State`}
					name={`${type}State`}
					readOnly={true}
					tabIndex={-1}
					value={state}
				/>
			</div>
			<div className={"pickup-delivery-zip"}>
				<Label editorId={`${type}Zip`}>Postal Code</Label>
				<TextBox
					disabled={true}
					id={`${type}Zip`}
					name={`${type}Zip`}
					readOnly={true}
					tabIndex={-1}
					value={postalCode}
				/>
			</div>
			<div className={"pickup-delivery-country"}>
				<Label editorId={`${type}Country`}>Country</Label>
				<TextBox
					disabled={true}
					id={`${type}Country`}
					name={`${type}Country`}
					readOnly={true}
					tabIndex={-1}
					value={country}
				/>
			</div>
		</div>
	);
}
